    import React, { useContext, useEffect, useState, useRef } from 'react';
    import { useLocation } from 'react-router';
    import MultiSelectEntity from '../RefineSearch/TgMultiSelectEntity';
    import { filterReSubsector} from "../../Config/config";
import { PeFilterContext } from '../../Contexts/PeFilterContext';

    const Subsectors = ({ options, setOptions, customPathname, label }) => {
    const [subsectorVal, setSubsectorVal] = useState("");
    const [fetchedData, setFetchedData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const location = useLocation();
    const { refineSearchFilters } = useContext(PeFilterContext);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (subsectorVal.trim() !== "") {
                fetchData();
            } else {
                setShowDropdown(false);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [subsectorVal]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
                inputRef.current && !inputRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    
    // Prevent dropdown from closing when interacting with checkboxes
    const handleDropdownMouseDown = (e) => {
        e.preventDefault();
    };

    const categoryval = location.pathname?.includes("exit") ? "exits" :
        location.pathname?.includes("backed-ipos") ? "ipo" :
        location.pathname?.includes("other-ma") ? "others"  : "investments";

    const fetchData = () => {
        const payload = {
        search_key: subsectorVal,
        category : categoryval,
        };
        
        fetch(filterReSubsector, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data?.results) {
                setFetchedData(data.results);
                setShowDropdown(true);
            }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            setFetchedData([]);
            setShowDropdown(false);
        });
    };

    useEffect(() => {
        if (!fetchedData || !Array.isArray(fetchedData)) return;

        setOptions(prev => {
            const filterItems = refineSearchFilters?.[customPathname]?.subSector || [];

            // Create map to store final options (id -> item)
            const itemMap = new Map();

            // 1. Add fetched data (default isChecked false)
            fetchedData.forEach(item => {
                itemMap.set(item.id, { ...item, isChecked: false });
            });

            // 2. Add previously selected items (prev) — only if still checked
            (prev || []).forEach(item => {
                if (item.isChecked) {
                    itemMap.set(item.id, item);
                }
            });

            // 3. Apply current filters — set isChecked as per latest filters
            filterItems.forEach(item => {
                itemMap.set(item.id, { ...item, isChecked: true });
            });

            return Array.from(itemMap.values());
        });
    }, [fetchedData, refineSearchFilters, customPathname]);


    const handleSubsectorChange = (e) => {
        const { name, checked, id } = e.target;
        let currentSubsector = [];

        if (name === "allSelect") {
            currentSubsector = options.map((subsector) =>
                ({ ...subsector, isChecked: checked })
            );
            setOptions(currentSubsector);
        } else {
            // Try both string and number comparison for ID matching
            currentSubsector = options.map((subsector) =>
                (subsector.id === id || subsector.id === parseInt(id) || subsector.id.toString() === id) 
                    ? { ...subsector, isChecked: checked } 
                    : subsector
            );
            setOptions(currentSubsector);
        }
    };

    const selectedSubsectorLength = options?.filter(option => option.isChecked)?.length ?? 0;
    const hasValue = subsectorVal || selectedSubsectorLength > 0;

    return (
        <div className="relative">
            <div className={`absolute left-3 transition-all duration-200 pointer-events-none flex items-center gap-2 z-10 ${
                isFocused || hasValue 
                    ? 'top-0 -translate-y-1/2 text-xs bg-white px-1 text-[#BC8B20]' 
                    : 'top-1/2 -translate-y-1/2 text-sm text-gray-500'
            }`}>
                <span>{label}</span>
                {(isFocused || hasValue) && selectedSubsectorLength > 0 && (
                    <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                        {selectedSubsectorLength}
                    </span>
                )}
            </div>
            
            <input
                ref={inputRef}
                type="text"
                value={subsectorVal}
                onChange={(e) => setSubsectorVal(e.target.value)}
                onFocus={() => {
                    setIsFocused(true);
                    if (fetchedData.length > 0) {
                        setShowDropdown(true);
                    }
                }}
                onBlur={() => {
                    setIsFocused(false);
                }}
                className="w-full md:w-[90%] px-4 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none bg-white"
                placeholder=""
            />
            
            {/* Search Results Dropdown */}
            {showDropdown && fetchedData.length > 0 && (
                <div 
                    ref={dropdownRef} 
                    className="px-2 absolute z-50 w-full md:w-[90%] top-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-64 overflow-y-auto"
                    onMouseDown={handleDropdownMouseDown}
                >
                    <MultiSelectEntity
                        fetchData={fetchData}
                        handleEntityChange={handleSubsectorChange}
                        primaryEntity={options}
                        setSubsectorVal={setSubsectorVal}
                        customPathname={customPathname}
                    />
                </div>
            )}
        </div>
    );
    };

    export default Subsectors;
